import Add16 from '@carbon/icons/es/add/16';
import Add32 from '@carbon/icons/es/add/32';
import AddAlt16 from '@carbon/icons/es/add--alt/16';
import AddFilled16 from '@carbon/icons/es/add--filled/16';
import ArrowsHorizontal16 from '@carbon/icons/es/arrows--horizontal/16';
import Attachment16 from '@carbon/icons/es/attachment/16';
import Batchjob16 from '@carbon/icons/es/batch-job/16';
import Box16 from '@carbon/icons/es/box/16';
import Close16 from '@carbon/icons/es/close/16';
import CloseFilled16 from '@carbon/icons/es/close--filled/16'
import CloseOutlined16 from '@carbon/icons/es/close--outline/16'
import ChevronLeft16 from '@carbon/icons/es/chevron--left/16';
import ChevronRight16 from '@carbon/icons/es/chevron--right/16';
import Dataenrichment from '@carbon/icons/es/data-enrichment/16';
import Document16 from '@carbon/icons/es/document/16';
import DocumentAdd16 from '@carbon/icons/es/document--add/16';
import DocumentAttachment16 from '@carbon/icons/es/document--attachment/16';
import DocumentPDF16 from '@carbon/icons/es/document--pdf/16';
import Edit16 from '@carbon/icons/es/edit/16';
import Export16 from '@carbon/icons/es/export/16';
import Flag16 from '@carbon/icons/es/flag/16';
import Link16 from '@carbon/icons/es/link/16';
import OverflowMenuVertical16 from '@carbon/icons/es/overflow-menu--vertical/16';
import OverflowMenuVertical32 from '@carbon/icons/es/overflow-menu--vertical/32';
import Return16 from '@carbon/icons/es/return/16';
import Save16 from '@carbon/icons/es/save/16';
import Settings16 from '@carbon/icons/es/settings/16';
import Subtract16 from '@carbon/icons/es/subtract/16';
import SubtractAlt16 from '@carbon/icons/es/subtract--alt/16';
import SubtractFilled16 from '@carbon/icons/es/subtract--filled/16';
import TrashCan16 from '@carbon/icons/es/trash-can/16';
import User16 from '@carbon/icons/es/user/16';
import View16 from '@carbon/icons/es/view/16';
import Wizard16 from '@carbon/icons/es/product/16';
import Workspace16 from '@carbon/icons/es/workspace/16';


export const iconMapping = {
  add: Add16,
  add32: Add32,
  addAlt: AddAlt16,
  addFilled: AddFilled16,
  arrowsHorizontal16: ArrowsHorizontal16,
  attachment: Attachment16,
  box: Box16,
  close16: Close16,
  closeFilled16: CloseFilled16,
  closeOutlined16: CloseOutlined16,
  chevronLeft16: ChevronLeft16,
  chevronRight16: ChevronRight16,
  dashboard: Workspace16,
  document: Document16,
  documentAdd: DocumentAdd16,
  documentAttachment: DocumentAttachment16,
  documentPdf: DocumentPDF16,
  edit: Edit16,
  export: Export16,
  flag: Flag16,
  link: Link16,
  opportunities: Dataenrichment,
  overflowMenuVertical: OverflowMenuVertical16,
  overflowMenuVertical32: OverflowMenuVertical32,
  return16: Return16,
  save: Save16,
  settings: Settings16,
  subtract: Subtract16,
  subtractAlt: SubtractAlt16,
  subtractFilled: SubtractFilled16,
  trashCan: TrashCan16,
  user: User16,
  view: View16,
  wizard: Wizard16,
  workorder: Batchjob16,
};


export default iconMapping;
